export const openScienceObjective = [
  {
    description:
      "Open Science is a revolutionary approach to scientific inquiry and knowledge dissemination that strives to make research more transparent, accessible, and collaborative. It represents a departure from traditional, closed-door research practices, aiming to democratize information and foster greater innovation and progress across the scientific community.",
  },
];

export const whatIsOpenScience = [
  {
    description:
      "At its core, Open Science embodies the idea that scientific research should be openly available, comprehensible, and shareable. It promotes a culture of transparency and inclusivity, where researchers and the public alike can engage with research findings, data, methodologies, and even the process of inquiry itself.",
  },
];

export const openScienceComponents = [
  {
    description:
      "<strong>Open Access:</strong> Open Access is a fundamental element of Open Science. It ensures that research outputs, including articles, data, and other scholarly works, are freely accessible online without financial, legal, or technical barriers.This wide accessibility accelerates the exchange of knowledge and enables collaboration.",
  },
  {
    description:
      "<strong>Open Data:</strong> Open Data involves making raw research data available to the public, allowing others to validate, analyze, and build upon the findings. Sharing data promotes reproducibility, innovation, and a higher level of scrutiny.",
  },
  {
    description:
      "<strong>Open Source:</strong> Open Source refers to making software, tools, and code openly available for others to use, modify, and enhance. This collaborative approach fosters innovation and the creation of more robust and reliable scientific tools.",
  },
  {
    description:
      "<strong>Open Peer Review: </strong>Open Peer Review involves making the peer review process transparent by allowing reviewer’s identities and comments to be accessible. This adds accountability and fairness to the evaluation process.",
  },
  {
    description:
      "<strong>Open Educational Resources:</strong> Open Peer Review involves making the peer review process transparent by allowing reviewer’s identities and comments to be accessible. This adds accountability and fairness to the evaluation process.",
  },
  {
    description:
      "<strong>Citizen Science:</strong> Open Peer Review involves making the peer review process transparent by allowing reviewer’s identities and comments to be accessible. This adds accountability and fairness to the evaluation process.",
  },
];

export const openAccessData = [
  {
    description:
      "Open Access (OA) is a movement that aims to make research and scholarly work freely available to anyone, anywhere. It ensures that research becomes accessible right after publication, without any barriers. By removing barriers to access, OA fosters the dissemination of knowledge on a global scale.",
  },
  {
    description:
      "Open Access (OA) Individuals with internet connectivity can easily discover, read, analyze, reference, and distribute OA articles without any financial burden. Opting for Open Access publication licenses enhances the fairness of information availability, amplifies the usefulness of your research, and promotes greater transparency.",
  },
];

export const didYouKnowData = [
  {
    description:
      "The Budapest Open Access Initiative in 2002 marked a significant step in defining the goals and strategies of the OA movement, of which Vikramshila Research Pvt Ltd (Owners of Aakashganga) is a <strong className='underline'> proud signatory. </strong>",
  },
  {
    description:
      "Aakashganga operates as a <strong className='underline'> Gold Open Access </strong>  publishing platform. Our commitment lies in making every article across our array of journals readily accessible online immediately upon publication.",
  },
  {
    description:
      "Our Open Access model ensures that information isn’t restricted by financial barriers, making it accessible to researchers, students, and curious minds from all walks of life.",
  },
  {
    description: `All articles published through Aakashganga are
      released under the<a
      href='https://creativecommons.org/licenses/by-nc-sa/4.0/'
      target='blank' class='colorBlack'> 
      <strong className='underline'>CC-BY-NY-SA</strong></a>
      license, allowing unrestricted utilization,
      distribution, and reproduction across various
      mediums, provided proper accreditation is given to
      the original authors and the source.`,
  },
  {
    description: `These endeavours are upheld through the charge of
    one of the lowest Article Processing Charges (APCs)
    in the world, so that everyone wanting to get their
    paper published has the financial opportunity to do
    so.`,
  },
  {
    description: `The platform offers multiple and discounts and the
    opportunity for researchers to apply for grants with
    the click of a button. It is our endeavour to bring
    researchers and grant offers on to the same platform
    thus eliminating the need for cumbersome grant
    writing and approval processes. We are currently
    focussed on India but in time we hope to expand
    grants to other developing nations too.`,
  },
  {
    description: `Our mission is to facilitate unhindered access to
    knowledge, and promote an equitable, inclusive and
    affordable platform for seeking, sharing, and
    creating knowledge that benefits society at large.
    With free access to research, scholars worldwide can
    build upon existing findings, leading to faster
    scientific advancements and innovation.`,
  },
  {
    description: `Our commitment towards Open Science is upheld
    through a meticulous and automated Peer Review
    Process of two kinds: 
    <strong className='underline'>
        Pre-Publishing Double Anonymous Peer Review 
    </strong>
    and 
    <strong className='underline'>
        Post Publication Open Peer Review.
    </strong>`,
  },
  {
    description: `This is further complemented by technological
    innovations, including automated Peer Reviewer and
    Publishing Editor selection, as well as online Peer
    Review reporting and Publishing Editor decision
    making.`,
  },
  {
    description: `Further, we support a researcher’s journey from
    start to end, with 95% automation, upholding
    research integrity, alongside global dissemination
    efforts.`,
  },
  {
    description: `By eliminating barriers inhibiting the unhampered
    distribution of knowledge, we aim to contribute to
    the transformation of India into a knowledge
    superpower and a global leader in Higher Education
    empowering creation of solutions crucial for
    fostering healthy lives on a thriving planet.`,
  },
  {
    description: `Alongside this objective we want to empower the
    developing world by providing an affordable,
    transparent and speedy publishing platform that is
    free from the expensive Western publishing models.`,
  },
];

export const publishOpenSurceReasonData = [
  {
    description: `<strong>Wider Audience: </strong>OA articles reach a
    broader readership, increasing the visibility and
    impact of author’s work.`,
  },
  {
    description: `<strong>Citation Advantage:</strong> Research
    published as OA often receives more citations,
    enhancing the academic reputation of authors.`,
  },
  {
    description: `<strong>Collaboration: </strong>OA encourages
    collaboration among researchers, fostering
    interdisciplinary studies and the exchange of ideas.`,
  },
  {
    description: `<strong>Citation Advantage:</strong> Research
    published as OA often receives more citations,
    enhancing the academic reputation of authors.`,
  },
  {
    description: `<strong>Policy Impact:</strong> Openly accessible
    research can influence public policies, contributing
    to evidence-based decision-making.`,
  },
];

export const howOpenAccessWorks = [
  {
    description: `Open Access operates through various models, often
    involving Creative Commons licenses. These licenses
    provide authors with the flexibility to choose how
    their work can be used by others. Creative Commons
    licenses include:`,
  },
  {
    description: `<strong>CC BY (Attribution):</strong> Allows others
    to distribute, remix, adapt, and build upon your
    work, even commercially, as long as they give
    appropriate credit.`,
  },
  {
    description: `<strong>CC BY-SA (Attribution-ShareAlike)</strong>:
    Similar to CC BY but requires adaptations of your
    work to be shared under the same license.`,
  },
  {
    description: `<strong className='underline'>
    CC BY-NC (Attribution-Non-commercial)</strong>: 
    Similar to CC BY but requires adaptations of your
    work to be shared under the same license.`,
  },
  {
    description: `Aakashganga follows the<a
    href='https://creativecommons.org/licenses/by-nc-sa/4.0/'
    target='blank'
  > <strong>CC-BY-NC-SA</strong></a>
    model of Creative Commons License.`,
  },
  {
    description: `The CC-BY-NC-SA Creative Commons license is a
    specific type of licensing framework that governs
    how a work can be used, shared, and distributed.
    Here&#39;s what each component of the license stands
    for:`,
  },
  {
    description: `CC-BY: This stands for “Attribution” Under this
    aspect of the license, others are allowed to use,
    distribute, and build upon your work, even for
    commercial purposes. However, they must provide
    appropriate credit to you as the original creator of
    the work.`,
  },
  {
    description: `NC: This stands for “Noncommercial” This component
    restricts others from using your work for commercial
    purposes without your permission. In other words,
    they cannot make money directly from your work
    without obtaining explicit consent.`,
  },
  {
    description: `SA: This stands for “ShareAlike” This aspect ensures
    that if others build upon your work or adapt it to
    create something new, they must license their new
    work under the same terms as the original
    (CC-BY-NC-SA). This helps maintain a consistent
    licensing approach for derivative works.`,
  },
  {
    description: `In summary, the CC-BY-NC-SA license allows others to
    use, remix, adapt, and distribute your work
    non-commercially, as long as they provide proper
    attribution to you and license their new works under
    the same terms. This license strikes a balance
    between allowing open collaboration and ensuring
    that the original creator is recognized and that
    subsequent works are also shared openly.`,
  },
];

export const Headings = {
  OPEN_SCIENCE_UNLOCKING_KNOWLEDGE:
    "Open Access",
    // "Open Access Sc<span>i</span>ence",

  WHAT_IS_OPEN_SCIENCE: "What Is Open Science?",
  COMPONENTS_OF_OPEN_SCIENCE: "Components Of Open Science:",
  PATHWAY_TO_KNOWLEDGE: "Open Access: A Pathway To Knowledge",
  DID_YOU_KNOW: "Did You Know?",
  WHY_SHOULD_YOU_PUBLISH_OPEN_ACCESS: "Why Should You Publish Open Access",
  HOW_OPEN_ACCESS_WORKS: "How Open Access Works",
};
